export const enum BankOperationStatusesNew {
  Created = 'created',
  OnApproval = 'on_approval',
  Rejected = 'rejected',
  Approved = 'approved',
  Canceled = 'canceled',
}
